import {FC, useMemo, useContext, ComponentProps} from 'react';
import {map, reject} from 'lodash';

import generateDashboardURI from '../generateDashboardURI';
import {PredefinedDashboard} from '../types';
import PredefinedEntityModal from './PredefinedEntityModal';
import MultiParagraphText from '../../components/MultiParagraphText';
import DashboardPreview from './DashboardPreview';
import IBAContext from '../IBAContext';

const generateResourceHref = ({blueprintId, entityId}) => generateDashboardURI({blueprintId, dashboardId: entityId});

type PredefinedDashboardModalProps = {
  predefinedDashboards: PredefinedDashboard[];
} & ComponentProps<typeof PredefinedEntityModal>;

const PredefinedDashboardModal: FC<PredefinedDashboardModalProps> = ({predefinedDashboards, ...props}) => {
  const {routes} = useContext(IBAContext);
  const predefinedDashboardsWithPreview = useMemo(() => {
    return map(reject(predefinedDashboards, {autoscaling: true}), (predefinedDashboard) => (
      {...predefinedDashboard, description: (
        <>
          <DashboardPreview dashboard={predefinedDashboard} />
          {predefinedDashboard.description &&
            <>
              <br />
              <MultiParagraphText asMarkdown text={predefinedDashboard.description} />
            </>
          }
        </>
      )}
    ));
  }, [predefinedDashboards]);

  return (
    <PredefinedEntityModal
      {...props}
      resourceName='Predefined Dashboard'
      entities={predefinedDashboardsWithPreview}
      baseRoute={routes.predefinedDashboardList}
      generateResourceHref={generateResourceHref}
      columnWidths={[7, 9]}
    />
  );
};

export default PredefinedDashboardModal;
